// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#top-shelf{background:var(--BackgroundPrimary);border-bottom:1px solid var(--black);display:flex;justify-content:space-between;min-height:25px}#top-shelf .top-shelf_right{align-items:center;display:flex;padding:0 1em}#top-shelf .top-shelf_right .home-button{cursor:pointer}#top-shelf .top-shelf_left{align-items:center;display:flex;justify-content:flex-end;padding:0 1em}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
